import React from 'react';
import FriendlyMatches from '../FriendlyMatches';

// Wrapper de amistosos dentro do admin.futezap.com.br. FriendlyMatches ja
// puxa /community/team-owner/my (que agora inclui times futezap do dono),
// entao funciona sem alteracoes.
export default function AdminCommunityFriendlies() {
  return <FriendlyMatches />;
}
